export const EXPERT_DATA = [
    {
        id: 1,
        heroImg: 'https://assets.learntube.ai/files/Optimized_premium_folder/mentors/arjun-lp.webp?updatedAt=1689922679279',
        name: 'Arjun Vaidya',
        designation: 'Ex-CEO, Dr. Vaidyas',
        description:
            'Arjun has founded and sold a very successful ayurvedic company which became a household name. With your 1:1 sessions, learn what marketing strategies he implemented to scale this billion dollar company. His journey has been featured on platforms like Forbes and YourStory and here is your chance to learn from the man himself!',
    },
    {
        id: 2,
        heroImg: 'https://assets.learntube.ai/files/Optimized_premium_folder/mentors/prajakta-lp.webp?updatedAt=1689922678925',
        name: 'Prajakta Rathe',
        designation: 'AVP Digital Marketing at My Glamm',
        description:
            'Prajakta has 11 Years of experience in the marketing domain and has worked with companies like BookMyShow, iProspect to name a few. She has also been a visiting faculty at NMIMS college in Mumbai and has a panache towards mentoring. She has been awarded the Top 100 Impact DigiPower 2020 Leader and Social Samosa Superwoman 2021',
    },
    {
        id: 3,
        heroImg: 'https://assets.learntube.ai/files/Optimized_premium_folder/mentors/nikunj-lp.webp?updatedAt=1689922679110',
        name: 'Nikunj Agarwal',
        designation: 'Co-founder and Lead Strategist, The Invisible Paintbrush',
        description:
            'Nikunj comes with an interesting background having worked in automobile, edu-tech, and agencies. He has worked with the likes of Uber and The Glitch as a senior account planner. Currently, in his entrepreneurial journey with his small but successful agency, he enjoys mentoring in his free time. Along with being a mentor at CareerNinja he also teaches "Advertising & Promotions Strategy" at ISME Mumbai.',
    },
    {
        id: 4,
        heroImg: 'https://assets.learntube.ai/files/Optimized_premium_folder/mentors/manish-lp.webp?updatedAt=1689922679190',
        name: 'Manish V. Dhanwani',
        designation: 'Associate Director of Marketing, MX Player',
        description:
            'Having worked with multiple interesting companies in the entertainment space like BookMyShow, SonyLIV, and now MX Player, Manish comes with a strong marketing background of 10+ years. He has won multiple awards for best-integrated marketing while working on popular shows like SCAM 1992 in his stint at SonyLIV. With recently hitting a billion downloads at MX Player, your career is off to sure-shot success under his guidance.',
    },
];

export const workAtsettings = {
    dots: false,
    slidesToShow: 7,
    rows: 1,
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 2000,
    easing: 'linear',
    cssEase: "linear",
    infinite: true,
    arrows: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3.75,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                infinite: true,
                dots: false,
                arrows: true,
                swipeToSlide: true,
            }
        }
    ]
};

export const featuredInsettings = {
    dots: false,
    slidesToShow: 5,
    rows: 1,
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 2000,
    easing: 'linear',
    cssEase: "linear",
    infinite: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 3,
                infinite: true,
                dots: false,
                arrows: false,
                swipeToSlide: true,
            }
        }
    ]
};

export const featureList = [
    {
        heading: "Top 1% Content",
        content: "Curated from across the world. No more time wasted looking for the best learning material.",
        img: "https://assets.learntube.ai/files/Optimized_LandingPagev3/features/mission.webp?updatedAt=1689929130701"
    },
    {
        heading: "Free Certified Learning",
        content: "Assessments & Certification for 1000s of micro-skills across 100s of in-demand skill domains.",
        img: "https://assets.learntube.ai/files/Optimized_LandingPagev3/features/variety.webp?updatedAt=1689929130717"
    },
    {
        heading: "Get Paid to Learn",
        content: "Earn coins for learning & redeem them for cash rewards & even iPhones",
        img: "https://assets.learntube.ai/files/Optimized_LandingPagev3/features/free-delivery.webp?updatedAt=1689929130648"
    },
    {
        heading: "Placement Support",
        content: "Interview preparation, portfolio & CV guidance and access to our network of 300+ employers.",
        img: "https://assets.learntube.ai/files/Optimized_LandingPagev3/features/certified.webp?updatedAt=1689929126351"
    },
    {
        heading: "Expert Led Doubt Solving",
        content: "Ask a doubt & get guaranteed responses from industry experts. No more getting stuck, ever!",
        img: "https://assets.learntube.ai/files/Optimized_LandingPagev3/features/expert.webp?updatedAt=1689929130663"
    },
    {
        heading: "No New App To Remember",
        content: "Install it once, and our Chrome Extension will help you get certified right inside YouTube!",
        img: "https://assets.learntube.ai/files/Optimized_LandingPagev3/features/easy.webp?updatedAt=1689929130720"
    },
]

export const HomepageBanner = [
    {
        image: "https://assets.learntube.ai/files/homepage-banner/image__66_.png?ik-sdk-version=javascript-1.4.3&updatedAt=1656999219806",
        ctaLink: "/login",
        ctaName: "Start Learning",
        isExternal: false,
        isScroll: true,
        index: 1,
    },
    {
        image: "https://assets.learntube.ai/files/homepage-banner/image__63_.png?ik-sdk-version=javascript-1.4.3&updatedAt=1656999219812",
        ctaLink: "/login",
        ctaName: "Get Certificate",
        index: 2,
        isScroll: true,
        isExternal: false
    },
    {
        image: "https://assets.learntube.ai/files/homepage-banner/image__65_.png?ik-sdk-version=javascript-1.4.3&updatedAt=1656999219972",
        ctaLink: "/login",
        ctaName: 'Start Learning',
        index: 3,
        isScroll: true,
        isExternal: false
    },
    {
        image: "https://assets.learntube.ai/files/homepage-banner/image__64_.png?ik-sdk-version=javascript-1.4.3&updatedAt=1656999219516",
        ctaLink: "/pricing",
        ctaName: "Get Started",
        index: 4,
        isScroll: false,
        isExternal: true
    },
]